package com.cybersoftsolution.cybersoftsolutionweb.models.ui


import com.cybersoftsolution.cybersoftsolutionweb.models.ConfigResponse

data class AdminHomePageUI(



    var serverConfig: ConfigResponse =ConfigResponse(),

    var toastMessage: ToastMessage = ToastMessage(),
    )


